import { Input as AntdInput, InputProps, Select, SelectProps } from 'antd';
import styled from 'styled-components';

export const TransformNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 8px;
  width: 382px;
`;

export const TransformNameBuilderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.65);
`;

export const TransformNameBuilderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 208px;
  overflow-y: scroll;
  background: #f7f7f7;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  border-top: 4px solid #52c41a;
  padding-top: 8px;
`;

export const TransformNameBuilderItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 16px;
  gap: 8px;
  width: 100%;
  height: 56px;
`;

export const ItemName = styled.div`
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.65);
`;

export const StyledInput = styled(AntdInput)<InputProps>`
  padding: 3px 7px;
  font-family: 'Roboto', sans-serif;
  border: 1px solid #b0b0b0;
  border-radius: 3px;

  &::before {
    line-height: 20px;
  }

  &.emp-ant-input-affix-wrapper:hover {
    border-color: #b0b0b0;
  }

  &.emp-ant-input-affix-wrapper:focus {
    border-color: #b0b0b0;
  }

  &.emp-ant-input-affix-wrapper:not(.emp-ant-input-affix-wrapper-disabled):hover {
    border-color: #b0b0b0;
  }

  & {
    .emp-ant-input {
      line-height: 20px;
      color: #949494 !important;
    }
  }
`;

export const StyledSelect = styled(Select)<SelectProps>`
  letter-spacing: -0.01em;

  & .emp-ant-select-selector {
    .emp-ant-select-selection-item {
      line-height: 20px;
      font-weight: 500;
    }

    .emp-ant-select-selection-placeholder {
      display: flex;
      align-items: center;
    }
  }

  &:not(.emp-ant-select-customize-input) .emp-ant-select-selector {
    padding: 3px 7px;
    border: 1px solid #b0b0b0;
    border-radius: 3px;
    height: 28px;

    .emp-ant-select-selection-search-input {
      height: 26px;
    }
  }

  &:not(.emp-ant-select-customize-input).emp-ant-select-disabled .emp-ant-select-selector {
    color: rgba(0, 0, 0, 0.45);
    background: rgba(0, 0, 0, 0.04);
  }
`;
